module.exports = __webpack_public_path__ + "img/medexperience-background.ef4b87bd.jpg";